// My List — mirrors WatchlistItem / WatchlistRepository in the Android app.
// Persisted in localStorage; the same data shape as the TV app.
import { useSyncExternalStore } from "react";
import { createStore } from "./store";

const store = createStore("poku.watchlist", []);

export function watchlistKey(contentType, tmdbId) {
  return `${contentType}:${tmdbId}`;
}

export function getAllWatchlist() {
  return store.getSnapshot();
}

export function isInWatchlist(contentType, tmdbId) {
  return getAllWatchlist().some((item) => item.contentType === contentType && item.tmdbId === tmdbId);
}

export function toggleWatchlist(item) {
  const key = watchlistKey(item.contentType, item.tmdbId);
  store.update((items) =>
    items.some((i) => watchlistKey(i.contentType, i.tmdbId) === key)
      ? items.filter((i) => watchlistKey(i.contentType, i.tmdbId) !== key)
      : [{ ...item, addedAtMillis: Date.now() }, ...items],
  );
  pushToServer();
}

export function mergeFromServer(items) {
  if (!Array.isArray(items)) return;
  store.update((local) => {
    const byKey = new Map(local.map((w) => [watchlistKey(w.contentType, w.tmdbId), w]));
    for (const srv of items) {
      if (!srv || !srv.contentType || !srv.tmdbId) continue;
      const k = watchlistKey(srv.contentType, srv.tmdbId);
      const cur = byKey.get(k);
      if (!cur || (srv.addedAtMillis || 0) >= (cur.addedAtMillis || 0)) byKey.set(k, srv);
    }
    return [...byKey.values()];
  });
}

// Fire-and-forget push (debounced; skipped when signed out) — same pattern
// as progress.js so My List follows the account across devices.
let pushTimer = null;
function pushToServer() {
  import("../api/auth.js").then(({ getAccount, syncNow }) => {
    if (!getAccount()?.token) return;
    if (pushTimer) clearTimeout(pushTimer);
    pushTimer = setTimeout(() => {
      pushTimer = null;
      syncNow(false).catch(() => {});
    }, 2000);
  }).catch(() => {});
}

export function removeFromWatchlist(contentType, tmdbId) {
  const key = watchlistKey(contentType, tmdbId);
  store.update((items) => items.filter((i) => watchlistKey(i.contentType, i.tmdbId) !== key));
  pushToServer();
}

export function useWatchlist() {
  return useSyncExternalStore(store.subscribe, store.getSnapshot);
}

// Builds a WatchlistItem from a MediaCard, mirroring MediaCard.toWatchlistItem().
export function watchlistItemFromCard(card) {
  return {
    contentType: card.contentType,
    tmdbId: card.tmdbId,
    title: card.title,
    overview: card.overview || "",
    posterPath: card.posterPath || null,
    backdropPath: card.backdropPath || null,
    date: card.date || null,
    rating: card.rating || 0,
  };
}